import { VueModule } from '@Foundation/utilities';
import TextBanner from './code/Scripts/components/text-banner';

export default VueModule({
  components: {
    TextBanner
  }
});
